import React from 'react';

const NotebookPanel = ({ children, className = '', title, annotation }) => {
  return (
    <div className={`relative bg-white border-4 border-ink-navy rounded-2xl overflow-hidden shadow-[12px_12px_0_0_#1e1b4b] ${className}`}>
      {/* Spiral Binding Detail */}
      <div className="absolute left-0 top-0 bottom-0 w-14 border-r-2 border-slate-200 bg-slate-50/50 z-10 flex flex-col items-center py-6 gap-6">
         {[...Array(8)].map((_, i) => (
           <div key={i} className="w-5 h-5 rounded-full border-2 border-slate-400 bg-white shadow-inner flex items-center justify-center">
             <div className="w-1 h-3 bg-slate-200 rounded-full"></div>
           </div>
         ))}
      </div>
      
      {/* Content Area */}
      <div className="ml-14 p-6 md:p-10 bg-notebook min-h-[250px] relative">
        {annotation && (
          <div className="absolute top-4 right-6 transform rotate-3 font-handwriting text-sky-blue text-xl hidden md:block">
            {annotation}
          </div>
        )}
        
        {title && (
          <div className="mb-6">
            <h3 className="font-handwriting text-4xl text-ink-navy leading-none">{title}</h3>
            <div className="h-1 w-24 bg-lemon-yellow mt-1 rounded-full"></div>
          </div>
        )}
        
        <div className="relative z-20 font-medium text-slate-700">
          {children}
        </div>
      </div>
    </div>
  );
};

export default NotebookPanel;